interface ErrorIconProps {
  className?: string | undefined;
}

/**
 * Big Wind error mark — the "B" logo glyph with an exclamation knocked
 * out of it. Exported from Figma node 359:17301 (Error component).
 *
 * The B fills with `--foreground-default`; the exclamation is painted in
 * `--surface-default` so it reads as a hole punched through the mark and
 * tracks the page background across themes. Intrinsic ratio 68.08×55.84.
 */
export function ErrorIcon({ className }: ErrorIconProps) {
  return (
    <svg viewBox="0 0 68.08 55.84" fill="none" aria-hidden className={className}>
      <path
        d="M60.32 26.4C65.36 29.2 68.08 33.36 68.08 38.56C68.08 43.76 65.52 55.84 41.76 55.84H0V0H41.52C59.36 0 65.76 8.16 65.76 15.84C65.76 20.32 63.84 23.92 60.32 26.4Z"
        fill="var(--foreground-default)"
      />
      <path
        d="M32.0693 37C33.7262 37 35.0693 38.3431 35.0693 40C35.0693 41.6569 33.7262 43 32.0693 43H32.04C30.3832 43 29.04 41.6569 29.04 40C29.04 38.3431 30.3832 37 32.04 37H32.0693ZM29.04 28V16C29.04 14.3431 30.3832 13 32.04 13C33.6969 13 35.04 14.3431 35.04 16V28C35.04 29.6569 33.6969 31 32.04 31C30.3832 31 29.04 29.6569 29.04 28Z"
        fill="var(--surface-default)"
      />
    </svg>
  );
}
